import { render, staticRenderFns } from "./ShareOrderInvitationRow.vue?vue&type=template&id=08654beb&scoped=true"
import script from "./ShareOrderInvitationRow.vue?vue&type=script&lang=js"
export * from "./ShareOrderInvitationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08654beb",
  null
  
)

export default component.exports